<div
  tabindex="0"
  class="layout-topbar layout-topbar-arsktrp"
  (click)="this.ixNgHtmlUtilsService.onTopbarMenuClick()"
  (keyup.enter)="this.ixNgHtmlUtilsService.onTopbarMenuClick()"
>
  <img
    class="rs-topbar-logo"
    [ngSrc]="
      IxNgHtmlStaticUtils.mobile ? 'assets/svg/RS-only-logo.svg' : 'assets/svg/RS-logo.427c0427.svg'
    "
    alt="logo"
    height="16"
    width="16"
    priority="high"
  />
  <a class="arsktrp-topbar-logo">
    <div>{{ this.nazivAplikacije }}</div>
    <lib-postavitev-info></lib-postavitev-info>
  </a>
</div>
